import React from "react";
import {
  Box,
  Typography,
} from "@mui/material";

interface HeaderSubtitleProps {
  children: React.ReactNode;
  marginTop?: boolean;
}

export const HeaderSubtitle: React.FC<HeaderSubtitleProps> = ({ children }) => {
  return (
    <Box sx={{ padding: "24px 24px 0 24px" }}>
      <Typography
        variant="subtitle2"
        color="text.secondary"
        sx={{
          fontWeight: 500,
          mb: 1,
          fontSize: "14px",
        }}
      >
        {children}
      </Typography>
    </Box>
  );
};
